import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// Le lingue dell'interfaccia (useLanguage.js).
const LINGUE_APP = ['it', 'en', 'es'];

/**
 * La lingua scelta nel profilo vale su ogni dispositivo, appena si entra (STU-529).
 *
 * Prima la rileggeva solo useLanguage, che e' montato dal selettore della lingua
 * (impostazioni, profilo, testata della landing): su un telefono nuovo l'app
 * restava in italiano finche' non si apriva una di quelle pagine. E la lingua
 * dell'app decide anche quella del tutor quando il materiale e' italiano.
 *
 * Solo lettura: non scrive niente su Firestore, lo fa useLanguage quando la
 * persona cambia lingua.
 */
const useLinguaDelProfilo = () => {
  const { i18n } = useTranslation();
  const preferita = useSelector((state) => state.user?.user?.preferredLanguage);

  useEffect(() => {
    const lingua = String(preferita || '').slice(0, 2).toLowerCase();
    if (!LINGUE_APP.includes(lingua) || typeof i18n?.changeLanguage !== 'function') return;
    const attuale = String(i18n.resolvedLanguage || i18n.language || '').slice(0, 2).toLowerCase();
    if (lingua !== attuale) {
      i18n.changeLanguage(lingua).catch((errore) => {
        console.warn('[lingua] lingua del profilo non applicata:', errore?.message);
      });
    }
  }, [preferita, i18n]);
};

export default useLinguaDelProfilo;
